// extracted by mini-css-extract-plugin
export default {"subscribers":"subscribers_subscribers__fPqZq"};